import { CampaignType } from 'generated-graphql/types';

type ShouldSourcingSharedShowCustomJobPostingUrlProps = {
  portalUrl: string | undefined | null;
  hasCustomJobPostingUrl: boolean;
  campaignType: CampaignType;
};

export const shouldSourcingSharedShowCustomJobPostingUrl = ({
  portalUrl,
  hasCustomJobPostingUrl,
  campaignType
}: ShouldSourcingSharedShowCustomJobPostingUrlProps): boolean => {
  if (portalUrl) {
    return false;
  }

  if (hasCustomJobPostingUrl) {
    return false;
  }

  if (campaignType === CampaignType.CustomJobApplicationUrlOutreach) {
    return true;
  }

  return false;
};
